<template>
    <div>

        <!-- <div>临时收费</div>  -->
        <div>
          <el-row :span="24">

              <el-col :span="6">
                <span>收费标准: </span>
                <el-select
                    :disabled="standardDisabledFlag"
                    v-model="itemsetId"
                    @change="standardIdChange"
                >
                    <el-option
                        v-for="item in standardList"
                        :key="item"
                        :value="item.itemsetId"
                        :label="item.sortTypeName"
                    >
                    </el-option>
                </el-select>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="6">
                <el-input placeholder="单价" v-model="itemFeePrice" disabled></el-input>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="6">
              <el-button type="primary" size="small" :disabled="addTempPayInfoBtnFlag" @click="addTempPayInfo">
                加入临时收费
              </el-button>
              </el-col>
          </el-row>

          <div style="padding:1rem 0;">
            临时费用预览
          </div>
          <el-table
            :data="tempFeeTableData"
          >
            <el-table-column
              type="index"
              width="50">
            </el-table-column>
            <el-table-column prop="sortTypeName" label="收费标准"></el-table-column>
            <el-table-column prop="cycleAmount" label="单价">
               <template slot-scope="scope">
                   <div>{{scope.row.cycleAmount}}</div>
                </template>
            </el-table-column>
              <!-- prop="account"  -->
            <el-table-column
              prop="account"
              label="数量"
            >
              <template slot-scope="scope">
                <!-- <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.date }}</span> -->
                <!-- <el-input
                  type="text"
                  maxlength="12"
                  v-model="scope.row.account"
                  @input="(e)=>{accountNumberChange(e,scope)}"
                >
                </el-input> -->
                <el-input-number :controls="false"  v-model="scope.row.account"
                  @input="(e)=>{accountNumberChange(e,scope)}" :min="0" :max="999999999.99" precision="2" ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="收费金额">
              <template slot-scope="scope">
                  <div v-if="parseInt(scope.row.pricingModel)==4">
                    <el-input v-model="scope.row.payPrice" placeholder="请输入 收费金额"></el-input>
                  </div>
                  <div v-else>{{Number(scope.row.cycleAmount*scope.row.account).toFixed(2)}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="cycleStartDate" label="开始日期">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.cycleStartDate"
                  type="date"
                  value-format="yyyy-MM-dd 00:00:00"
                  placeholder="选择日期">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="cycleEndDate" label="结束日期">
              <template slot-scope="scope">
                <el-date-picker
                  v-model="scope.row.cycleEndDate"
                  type="date"
                  value-format="yyyy-MM-dd 23:59:59"
                  placeholder="选择日期">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="shouldPayAmount" label="本次应收">
              <template slot-scope="scope">
              <div>{{Number(scope.row.account*scope.row.cycleAmount).toFixed(2)}}</div>
              </template>

            </el-table-column>
          </el-table>
          <div style="padding:1rem 0;">
            费用合计: {{Number(billPay.sumOfAmount).toFixed(2)}}
          </div>
          <div style="text-align:right;">
            <el-button type="primary" @click="billPayFunc">
              收费
            </el-button>
          </div>
        </div>

        <el-dialog title="收款信息" append-to-body :visible.sync="billTempPayBoxFlag">
            <div style="display:flex;text-align:center;padding-bottom:1rem;">
                <div style="flex:1">房间:{{communityName}}</div>
                <div style="flex:1">客户：{{zhxx.householder}}</div>
                <div style="flex:1">费用合计：{{Number(billPay.sumOfAmount).toFixed(2)}}元</div>
            </div>
            <avue-form
                ref="billPayForm"
                v-if="billTempPayBoxFlag"
                :option="billPayFormOption"
                v-model="billPayForm"
            >

                <template slot="coupon">
                    <el-input type="text" v-model="billPayForm.coupon" maxlength="20" placeholder="请输入优惠券码"></el-input>
                </template>
                <template slot="authCode">
                    <!-- v-if="showAuthCodeFlag" -->
                    <el-input type="password" ref="authCodeInput" v-model="billPayForm.authCode" @blur="blurHandler" @input="inputHandler" @focus="focusHandler" maxlength="18" placeholder="请输入优惠券码"></el-input>
                </template>
                <template slot="payType">
                    <el-select
                        v-model="billPayForm.payType"
                        @change="payTypeChange"
                    >
                        <el-option
                            v-for="item in payTypeList"
                            :key="item"
                            :value="item.dictKey"
                            :label="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </template>

                <template slot="payScene">
                    <el-select
                        v-model="billPayForm.payScene"
                        @change="paySceneChange"
                    >
                        <el-option
                            v-for="item in paySceneList"
                            :key="item"
                            :value="item.dictKey"
                            :label="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </template>


            </avue-form>
            <div style="padding:1rem;overflow:hidden;">
                <div style="float:right;">
                    <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
                    <el-button @click="cancelPay" type="normal">取消</el-button>
                </div>
            </div>
        </el-dialog>

            <el-dialog
                :title="payScene==6?'查询中':'收款码'"
                :visible.sync="payInfo2.showQrCode"
                :close-on-click-modal="false"
                width="30%"
                top="16vh"
                append-to-body
                @close="closeQrCode"
            >
                <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
                    {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
                </div>
                <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
                    扫码支付后请勿手动关闭弹窗
                </div>
                <div style="text-align: center">
                    <div id="qrcodeTempFee" ref="qrcode" style="display: inline-block"></div>
                    <div>倒计时：{{ payInfo2.countdown }}</div>
                </div>
            </el-dialog>


            <el-dialog
                :title="payScene==6?'查询中':'收款码'"
                :visible.sync="statusDialogVisible"
                :close-on-click-modal="false"
                width="30%"
                top="16vh"
                append-to-body
                @close="closeQrCode_"
            >
                <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
                    {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
                </div>
                <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
                    扫码支付后请勿手动关闭弹窗
                </div>
                <div style="text-align: center">
                    <!-- <div id="qrcodeTempFee" ref="qrcode" style="display: inline-block"></div> -->
                    <div>倒计时：{{ statusDuration }}</div>
                </div>
            </el-dialog>

            <printPreview ref="printPreview"></printPreview>
    </div>
</template>

  <script>
import dayjs from 'dayjs';
import QRCode from 'qrcodejs2';
import NP from 'number-precision';
    import {mapGetters, mapState} from "vuex";
    import printPreview from '@/views/v4ward/pay/printdialog-new/printPreview';
  import {
        getTemppayItemsetList,
        getTemppayInfo,
        getPayTypeList,
        getPaySceneList,
        loadPayStatusPlatform,
    } from '@/api/charge/charge-pay';


  import {
        saveQrCodePay_,
        loadZhxx,
        saveBarCodePay,
        saveAllBill,
        loadPayStatus
    } from '@/api/charge';
    export default {
      components: { printPreview },
      data() {
        return {
          statusDuration:120,
          addTempPayInfoBtnFlag:false,
          showAuthCodeFlag:false,
          payTypeList:[],
          paySceneList:[],
          billPayForm:{

          },
          payInfo:{
              payBillNo:''
          },
          payInfo2:{
              timer:'',
              showQrCode:false,
              countdown:'',
              tradeStatus:'',
              payDetailList:[]
          },
          billPay:{},
          zhxx:{},
          temppayInfo:{},
          itemFeePrice:'',
          roomId:'',
          billTempPayBoxFlag:false,
          standardDisabledFlag:false,
          itemsetId:'',
          standardList:[],
          tempFeeTableData:[],
          payBillList:[],
        }
      },
      computed:{

        ...mapGetters(["tagList"]),
        ...mapGetters(['permission']),
        permissions() {
            return {
                propertyAmountCheck: this.vaildData(
                this.permission.propertyCharge_propertyAmountCheck,
                false
                ),
                otherAmountCheck: this.vaildData(this.permission.propertyCharge_otherAmountCheck, false),
                proxyAmountCheck: this.vaildData(this.permission.propertyCharge_proxyAmountCheck, false),
                byMonthCar: this.vaildData(this.permission.propertyCharge_byMonthCar, false),
                byTempCar: this.vaildData(this.permission.propertyCharge_byTempCar, false),
                byNoSubsidy: this.vaildData(this.permission.propertyCharge_byNoSubsidy, false),
            };
        },

    payParams() {
      let params = this._.merge(
        {
          roomId: this.zhxx.roomId,
          roomName: this.zhxx.roomName,
          payManId: this.payManId,
          payInfo: this.payInfo,
          householdName: this.zhxx.householder,
        },
        {
          payInfo: {
    //           "billTotalAmount": 5,
    // "preTotalAmount": 0,
    // "carTotalAmount": 0,
    // "temporaryTotalAmount": 0,
    // "totalShouldAmount": 5,
    // "accountAmount": 0,
    // "totalAccountpayAmount": 0,
    // "totalPayAmount": 5,
    // this.payInfo.totalPayAmount = NP.strip(
    //     this.totalShouldAmountCP - this.payInfo.totalAccountpayAmount
    //   );
            billTotalAmount: this.billTotalAmountCP,
            preTotalAmount: 0,
            carTotalAmount: 0,
            temporaryTotalAmount: 0,
            totalShouldAmount: this.totalShouldAmountCP,
            totalAccountpayAmount: 0,
            totalPayAmount: this.totalShouldAmountCP,
            payDetail: JSON.stringify(this.payInfo2.payDetailList),
          },
        }
      );
        params.temporaryPayV1 = this.tempFeeTableData;
      return params;
    },


    billTotalAmountCP() {
      return Number(this.billPay.sumOfAmount);
    },
    totalShouldAmountCP() {
      return (
        this.billTotalAmountCP
      );
    },
       billPayFormOption(){
         return{
            menuBtn:false,
            column: [{
                        label: "优惠券",
                        prop: "coupon",
                        formslot:true,
                        span: 12
                    },{
                        label: "收款方式",
                        prop: "payType",
                        formslot:true,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择收款方式",
                            trigger: "blur"
                        }],
                    },{
                        label: "收款类型",
                        prop: "payScene",
                        formslot:true,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择收款类型",
                            trigger: "blur"
                        }],
                    },{
                        label: "付款码",
                        prop: "authCode",
                        formslot:true,
                        display:false,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请输入付款码",
                            trigger: "blur"
                        }],
                    },{
                        label: "收款备注",
                        prop: "description",
                        span: 24,
                        type: "textarea",
                    },]
            }
        }
      },
      methods:{
            clearData(){
              this.itemsetId =''
              this.itemFeePrice =''
              this.tempFeeTableData =[]
              this.billPay.sumOfAmount =0
            },

            //打印预览
            printprev() {
              this.$confirm('收费成功，是否需要打印收据？', '提示', {
                    confirmButtonText: '打印',
                    cancelButtonText: '取消',
                    closeOnClickModal:false,
                    type: 'warning'
                }).then(() => {
                  if (
                        this.payInfo.payBillNo != ''
                        // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
                    ) {
                      this.$refs.billPayForm.resetForm();

                      this.billTempPayBoxFlag = false;
                      this.itemsetId = '';
                      // this.loadBillList(this.targetId,'','');
                      this.tempFeeTableData = [];
                      this.billPay.sumOfAmount = '';
                      this.itemFeePrice = '';
                      this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
                    } else {
                        this.$message.warning('请先完成收款');
                    }

                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                    //重置数据
                    this.itemsetId = '';
                    this.$refs.billPayForm.resetForm();
                    this.tempFeeTableData = [];
                    this.billPay.sumOfAmount = '';
                    this.itemFeePrice = '';
                    this.billTempPayBoxFlag = false;
                    this.loadBillList(this.targetId,'','');
                    // this.resetAllData();
                });

            },
            //关闭二维码
            closeQrCode() {
                setTimeout(() => {
                    this.$refs.qrcode.innerHTML = '';
                }, 300);
                clearInterval(this.payInfo2.timer);
            },
            //关闭二维码
            closeQrCode_() {
                setTimeout(() => {
                    // this.$refs.qrcode.innerHTML = '';
                }, 300);
                clearInterval(this.payInfo2.timer);
            },
            payTypeChange(val){
                if(val){
                    this.billPayForm.payScene = '';
                    if(parseInt(val)==1 || parseInt(val)==8 || parseInt(val)==11){
                        this.$refs.billPayForm.columnOption[0].column[3].display=false;
                        this.showAuthCodeFlag = false;
                        this.$refs.billPayForm.columnOption[0].column[2].display=false;
                    }else{
                        this.showAuthCodeFlag = true;
                        this.$refs.billPayForm.columnOption[0].column[2].display=true;
                    }
                    getPaySceneList({payType:val}).then((res)=>{
                        this.paySceneList = res.data;
                        console.log(res);
                    });
                }
            },
          paySceneChange(val){
              console.log(this.$refs.billPayForm);
              if(parseInt(val)==6){
                  this.showAuthCodeFlag = true;
                  this.$refs.billPayForm.columnOption[0].column[3].display=true;
              }else{
                  this.showAuthCodeFlag = false;
                  this.$refs.billPayForm.columnOption[0].column[3].display=false;
              }
          },
    //查询住户信息
    queryZhxx(params) {
      loadZhxx(params).then(({ data }) => {
        this.zhxx = data[0];
      });
    },
    isPayBillLock(feeBillList) {
      let isLock = false;
      let index_ = 0;
      for (let index = 0; index < feeBillList.length; index++) {
        // const element = feeBillList[index];
        if (parseInt(feeBillList[index].lockFlag) == 1) {
          isLock = true;
          index_ = index;
          break;
        }
      }
      // feeBillList.forEach((v,i)=>{
      //   console.log(v,i);
      // });
      return { isLock, index_: index_ };
    },
    //选中
    confirmBillPay() {
      // this.payInfo.authCode
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      if (this.vdui.isEmpty(this.payBillList)) {
        this.$message.warning('请选择账单');
        return;
      }

      // let arrayLength = this.payBillList.length;
      // this.billPay.feeBillList.push(this.billPay.feeBillList[arrayLength-1]);
      // this.billPay.feeBillList[arrayLength-1].lockFlag = 1;
      console.log(this.payBillList);
      console.log(this.isPayBillLock(this.payBillList));

      let isLockedObject = this.isPayBillLock(this.payBillList);
      let self = this;

      if (isLockedObject.isLock) {
        this.$message.warning(
          `"${self.payBillList[isLockedObject.index_].billFeeItemName}"正在划扣中！`
        );
        return;
      }
      // return;
    //   this.selected.billPay = true;
      this._.forEach(self.payBillList, (item) => {
        this.payInfo2.payDetailList.push({
          feeType: 'temporaryPay',
          feeName: item.billFeeItemName,
          feePeriod: item.billStartDate + ' - ' + item.billEndDate,
          calAmount: item.calAmount + '',
          derateAmount: item.billPreferentAmount + '',
          couponAmount: item.billCouponAmount + '',
          shouldAmount: item.billShouldAmount + '',
        });
      });
        this.openBillPayBox();

    },
     outNumber(e,max=9999.99){
                        let value = e;
                        value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
                        value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                        value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
                        if (value.indexOf(".") < 0 && value != "") {
                                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                                value = parseFloat(value);
                        }
                        value = String(value);
                        if(value.indexOf('.')==4){
                                value=value.slice(0,8)
                        }
                        else if(value.indexOf('.')==2){
                             value=value.slice(0,6)
                        }
                        else{
                            value = value.slice(0,9)
                        }
                        if(value=='.'){
                                value = '0.'
                        }

                        return value;
                },
           accountNumberChange(e,scope){
          // scope.row.account=this.outNumber(e);
          this.tempFeeTableData[0].money = this.tempFeeTableData[0].account* this.tempFeeTableData[0].cycleAmount

          scope.row.shouldPayAmount=scope.row.account*scope.row.cycleAmount
          console.log(scope.row.account,scope,'$$$$$$$$$$$$');
          let moneySum =0
          this.tempFeeTableData.forEach((element,index) => {
            console.log(element)
            moneySum+=element.shouldPayAmount
            // element.shouldPayAmount=Number( element.shouldPayAmount).toFixed(2)
          })
          this.billPay.sumOfAmount= Number(moneySum).toFixed(2)

          // setTimeout(()=>{
          //   this.calculateAccount(scope.$index);
          //   this.sumAllAccountFunc();
          // });
        },
        addTempPayInfo(){
          let self = this;
          let repeatFlag = false;
          let tempIndex = 0;
          console.log("self.temppayInfo====>",self.temppayInfo);
          if(self.itemFeePrice){
            self.tempFeeTableData.forEach((element,index) => {
              if(element.itemsetId===self.temppayInfo.itemsetId){
                repeatFlag = true;
                tempIndex = index;
              }
              // console.log("element.cycleStartDate====>",element.cycleStartDate+'');
              // console.log("element.cycleStartDate====>",(element.cycleStartDate).splice(' ')[0]);
              // if(!repeatFlag){
              //   if(element.cycleStartDate){
              //     self.tempFeeTableData[index].cycleStartDate = element.cycleStartDate.splice(' ')[0];
              //   }
              //   if(element.cycleEndDate){
              //     self.tempFeeTableData[index].cycleEndDate = element.cycleEndDate.splice(' ')[0];
              //   }
              // }
            });
            if(repeatFlag){
              //删除加一功能
              // self.tempFeeTableData[tempIndex].account = parseInt(self.tempFeeTableData[tempIndex].account)+1;
              // self.calculateAccount(tempIndex);
              // // setTimeout(()=>{
              //   self.sumAllAccountFunc();
              // // })
            }else{
              self.tempFeeTableData.push({
                ...self.temppayInfo,
                account:1,
                money:self.temppayInfo.cycleAmount,
                shouldPayAmount:self.temppayInfo.cycleAmount
                });
              self.sumAllAccountFunc();
            }
          }
        },
        calculateAccount(index){
          let self = this;
          self.tempFeeTableData[index].money = (self.tempFeeTableData[index].cycleAmount*self.tempFeeTableData[index].account).toFixed(2);
          self.tempFeeTableData[index].shouldPayAmount = self.tempFeeTableData[index].money;
        },
        sumAllAccountFunc(){
          let self = this;
          let sumAllAccount = 0;
          setTimeout(()=>{
            self.tempFeeTableData.forEach((element,index) => {
              sumAllAccount = parseFloat(sumAllAccount) + parseFloat(element.shouldPayAmount);
            });
            console.log(sumAllAccount);
            self.billPay.sumOfAmount = parseFloat(sumAllAccount).toFixed(2);
            self.billPay = Object.assign({},self.billPay,{sumOfAmount:parseFloat(sumAllAccount).toFixed(2)})
            console.log(self.billPay.sumOfAmount);
          })
        },
        standardIdChange(val){
          this.addTempPayInfoBtnFlag = true;
          console.log(val);
          getTemppayInfo({roomId:this.roomId,itemsetId:val}).then((res)=>{
            this.itemFeePrice = res.data.cycleAmount;
            console.log(res);
            this.temppayInfo = res.data;
            this.addTempPayInfoBtnFlag = false;
            // this.standardList = res.data;
          });
        },
        getFeeTypeList(targetId,targetName,subjectIds,householderName){
          this.roomId = targetId;
          this.zhxx.householder = householderName;
            if(targetName){
                this.communityName = targetName;
            }
          getTemppayItemsetList({roomId:targetId}).then((res)=>{
            console.log(res);
            this.standardList = res.data;
          });
        },
        billPayFunc(){
          this.payBillList = this.tempFeeTableData;
              if(this.payBillList.length==0){
                  this.$message.error('请先选择账单!');
                  return;
              }
              this.billPayForm = {};
              this.confirmBillPay();
              this.queryZhxx({ roomId: this.roomId });
              getPayTypeList().then((res)=>{
                  console.log(res);
                  this.payTypeList = res.data;
              });
        },
        openBillPayBox(){
          this.billTempPayBoxFlag = true;
        },
          cancelPay(){
              this.billTempPayBoxFlag = false;
          },
            confirmPayAction(){
              this.tempFeeTableData.forEach((ele,index)=>{
                ele.cycleEndDate = dayjs(ele.cycleEndDate).format('YYYY-MM-DD 00:00:00')
              });
                console.log(this.payParams);
                // return;
                this.genearateQrCode()
            },
            //生成二维码
            genearateQrCode() {
                this.$refs.billPayForm.validate((valid) => {
                    if (valid) {
                        // this.getBillFormData();
                        this.payParams.payInfo.payType = this.billPayForm.payType;
                        this.payParams.payInfo.authCode = this.billPayForm.authCode;
                        console.log("this.billPayForm.payType====>",this.billPayForm.payType);
                        if(parseInt(this.billPayForm.payScene)==5){
                            this.qrCodePay();
                        }else if(parseInt(this.billPayForm.payScene)==6){
                            this.authCodePay();
                        }else{
                            this.normalPay();
                        }
                    }
                });
            },
            qrCodePay(){

                        saveQrCodePay_(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            this.payInfo2.showQrCode = true;
                            this.payInfo.payBillNo = data.payBillNo;
                            this.$nextTick(() => {
                                new QRCode('qrcodeTempFee', {
                                width: 250,
                                height: 250,
                                text: data.codeUrl,
                                });
                            });
                            this.payInfo2.showQrCode = true;
                            this.payInfo2.countdown = 120;
                            this.payInfo2.timer = setInterval(() => {
                                if (this.payInfo2.countdown === 0) {
                                    clearInterval(this.payInfo2.timer);
                                    this.payInfo2.showQrCode = false;
                                    this.$message.info('倒计时结束，二维码弹窗关闭');

                                    this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
                                        confirmButtonText: '更新账单',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        // this.$message({
                                        //     type: 'success',
                                        //     message: '删除成功!'
                                        // });
                                        // this.printprev()
                                        let {tag, key} = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                                        this.$store.commit("DEL_TAG", tag);
                                        this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal`});
                                    }).catch(() => {
                                        // this.$message({
                                        //     type: 'info',
                                        //     message: '已取消删除'
                                        // });
                                        //重置数据
                                        this.resetAllData();
                                    });

                                    // this.resetAllData();
                                    // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});

                                }
                                if (this.payInfo2.countdown % 5 === 0) {
                                    loadPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
                                        this.payInfo2.tradeStatus = data.tradeStatus;
                                        if (parseInt(data.tradeStatus) == 2) {
                                            this.payInfo2.showQrCode = false;
                                            this.$message.success('支付成功');
                                            this.isSuccess = true;
                                            clearInterval(this.payInfo2.timer);

                                            this.printprev();
                                        }
                                    });
                                }
                                this.payInfo2.countdown--;
                            }, 1000);
                            }
                        );
            },
            authCodePay(){

                        saveBarCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            // this.payInfo2.showQrCode = true;
                            this.payInfo.payBillNo = data.payBillNo;
                            this.isSuccess = true;
                            this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
                            console.log('data==>', data);
                            // fix:2021-03-19 条码支付轮询支付状态,注:这里必须是字符串 'false'
                            if (data.payBillNo && data.isSuccess == 'false') {
                            this.openMaskAndPollingPayStatus();
                            }else{

                            this.openMaskAndPollingPayStatus();
                            //   this.printprev();
                            // this.payInfo2.tradeStatus = 2;
                            }
                            // fix end
                            // this.submitAllBill();
                            //清楚数据
                            // this.resetAllData();
                            }
                        );
            },

            normalPay(){
                this.submitAllBill();
                        // saveQrCodePay_(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                        //     ({ data }) => {
                        //     this.payInfo.payBillNo = data.payBillNo;
                        //         loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                        //             this.payInfo2.tradeStatus = data.payStatus;
                        //             if (parseInt(data.payStatus) == 1) {
                        //             this.$message.success('支付成功');
                        //             //重置数据
                        //             this.resetAllData();
                        //             // this.submitAllBill();
                        //             }
                        //         });
                        //     }
                        // );
            },
            //保存账单
            submitAllBill() {
            saveAllBill(this.payParams, { showLoading: { text: '处理中' } }).then(({ data, msg }) => {
                this.payInfo.payBillNo = data.payBillNo;
                this.isSuccess = data.isSuccess;
                this.$message.success(msg);
                this.printprev();
                this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
                //清楚数据
                // this.resetAllData();
            });
            },
            resetAllData(){
                location.reload();
            },
            openMaskAndPollingPayStatus() {
                  this.statusDuration = 120;
              this.statusDialogVisible = true;
              let timer = setInterval(() => {
                console.log('this.status==>', this.statusDuration);
                this.statusDuration--;
                console.log('this.status==>', typeof this.statusDuration);
                if (this.statusDuration <= 0) {
                  this.$message.error('支付失败');
                  this.statusDialogVisible = false;
                  clearInterval(timer);
                  this.statusDuration = 120;
                  window.location.reload();
                } else {
                  if (this.statusDuration % 5 == 0) {
                    loadPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
                      console.log('res pooling  data==>', data);
                      if (data.tradeStatus === 2) {
                        this.payInfo2.tradeStatus = data.tradeStatus;
                        this.$message.success('支付成功');

                        this.statusDialogVisible = false;
                        clearInterval(timer);
                        this.statusDuration = 120
                        this.printprev();
                      }
                    });
                  }
                }
              }, 1000);
            },
      }
    }
  </script>

<style>

</style>
